import { ContentSection, DividerList, LabeledListItem } from '@mews-commander/ui';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { GeneralPricingMode } from '@mews-commander/data-access';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useAllowancesGet } from '../../queries/useAllowancesGet';
import { ChargingSection } from './PricingTabContent/ChargingSection';
import { TaxationList } from './PricingTabContent/TaxationList';

interface Props {
    allowanceId: string;
}
export const AllowancePricingTabContent = ({ allowanceId }: Props) => {
    const { allowance, price, charging, consumptionMoment, allowanceProfitTaxRateCode } = useAllowancesGet({
        allowanceId,
    });
    const { pricing: enterprisePricing } = useCurrentEnterprise();

    return (
        <Stack spacing="400" vertical>
            <ContentSection title={lt('Pricing')}>
                <DividerList>
                    <LabeledListItem label={lt('Currency')}>{price.currency}</LabeledListItem>
                    <LabeledListItem label={lt('Price')}>
                        <LocalizedCurrencyValue
                            value={{
                                value:
                                    enterprisePricing === GeneralPricingMode.Gross ? price.grossValue : price.netValue,
                                currency: price.currency,
                            }}
                        />
                    </LabeledListItem>
                    <LabeledListItem label={lt('AllowanceFormInputLabelAllowance')}>
                        <LocalizedCurrencyValue
                            value={{
                                value: allowance.creditAmount,
                                currency: allowance.currency,
                            }}
                        />
                    </LabeledListItem>
                </DividerList>
            </ContentSection>
            <ContentSection title={lt('Tax')}>
                <Typography textStyle="bodyLargeStrong" as="div">
                    {lt('AllowanceAccountingCategoryProfit')}
                </Typography>
                <DividerList>
                    <TaxationList taxRateCodes={allowanceProfitTaxRateCode ? [allowanceProfitTaxRateCode] : []} />
                </DividerList>
            </ContentSection>
            <ChargingSection charging={charging} consumptionMoment={consumptionMoment} />
        </Stack>
    );
};
